// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Insured-module__formBox--RCzjX {
    flex-grow: 1;
    padding: 20px;
    border-radius: 16px;
    width: 80%;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
}

.Insured-module__btnBoxNext--cdYOg {
    display: flex;
    justify-content: space-between;
}

.Insured-module__titleBox--Eq09l>h4 {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 500;
    color: var(--color-title);
}
.Insured-module__titleOterBox--gJRZp>h4 {
    margin: 15px 0 10px 0;
    font-size: 18px;
    font-weight: 500;
    color: var(--color-title);
}


.Insured-module__titleBox--Eq09l>p {
    margin: 10px 0 20px 0;
    font-size: 14px;
    font-weight: 500;
    color: var(--color-title);
}

.Insured-module__twoLine--jixgu {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;
}

.Insured-module__twoLine--jixgu>div {
    width: 50%;
    max-width: 350px;
}

.Insured-module__errorBox--B6i9h {
    margin: 20px 0;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #ffe2e2;
    border-radius: 20px;
    padding: 5px;
}

.Insured-module__textErrorBox--leul7>p {
    margin: 0;
    font-size: 15px;
}

.Insured-module__iconRed--Hy9JP {
    color: var(--color-error);
    font-size: 25px;
}

@media (max-width: 950px) {
    .Insured-module__twoLine--jixgu {
        flex-direction: column
    }

    .Insured-module__twoLine--jixgu>div {
        width: 100%;
    }

    .Insured-module__formBox--RCzjX {
        width: 80%;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/health-ai/step-2/ui/Insured.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;;AAGA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".formBox {\r\n    flex-grow: 1;\r\n    padding: 20px;\r\n    border-radius: 16px;\r\n    width: 80%;\r\n    margin: 0px auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.btnBoxNext {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.titleBox>h4 {\r\n    margin: 0 0 20px 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n}\r\n.titleOterBox>h4 {\r\n    margin: 15px 0 10px 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n}\r\n\r\n\r\n.titleBox>p {\r\n    margin: 10px 0 20px 0;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n}\r\n\r\n.twoLine {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.twoLine>div {\r\n    width: 50%;\r\n    max-width: 350px;\r\n}\r\n\r\n.errorBox {\r\n    margin: 20px 0;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #ffe2e2;\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.textErrorBox>p {\r\n    margin: 0;\r\n    font-size: 15px;\r\n}\r\n\r\n.iconRed {\r\n    color: var(--color-error);\r\n    font-size: 25px;\r\n}\r\n\r\n@media (max-width: 950px) {\r\n    .twoLine {\r\n        flex-direction: column\r\n    }\r\n\r\n    .twoLine>div {\r\n        width: 100%;\r\n    }\r\n\r\n    .formBox {\r\n        width: 80%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `Insured-module__formBox--RCzjX`,
	"btnBoxNext": `Insured-module__btnBoxNext--cdYOg`,
	"titleBox": `Insured-module__titleBox--Eq09l`,
	"titleOterBox": `Insured-module__titleOterBox--gJRZp`,
	"twoLine": `Insured-module__twoLine--jixgu`,
	"errorBox": `Insured-module__errorBox--B6i9h`,
	"textErrorBox": `Insured-module__textErrorBox--leul7`,
	"iconRed": `Insured-module__iconRed--Hy9JP`
};
export default ___CSS_LOADER_EXPORT___;
